import Modal from "./MyModal";

export default Modal